module.exports = __webpack_public_path__ + "img/Dantam Hair 09.de961652.jpg";